var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:_vm.className ?? 'relative -top-2.5'},_vm._l((_vm.messages),function(msg){return _c('li',{staticClass:"relative text-[1rem]",class:(_vm.variant === 'ab' ? 'text-ab-red-500' : 'text-red-400')},[_vm._v("\n    "+_vm._s(msg)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }